export default __webpack_public_path__ + "static/media/hellobar-logo-white.c5c13b8d.png";